import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { ShieldCheck } from "lucide-react";
import { migApi, errMsg, ROW_STYLE } from "../lib";

const COUNT_LABELS = [["ready", "Ready"], ["warning", "Warning"], ["error", "Error"], ["duplicate", "Possible Duplicate"], ["skipped", "Skipped"]];

export function ValidationSummary({ validation }) {
  if (!validation) return null;
  const c = validation.counts || {};
  return (
    <div className="space-y-2">
      <div className="grid grid-cols-5 gap-1" data-testid="mig-validate-counts">
        {COUNT_LABELS.map(([k, l]) => <div key={k} className={`rounded-md px-2 py-1.5 text-center ${ROW_STYLE[k]}`}><p className="text-base font-bold leading-none" data-testid={`mig-count-${k}`}>{c[k] ?? 0}</p><p className="text-[9px] uppercase tracking-wide mt-0.5">{l}</p></div>)}
      </div>
      {validation.preview?.length > 0 && (
        <div className="rounded-lg border border-border divide-y divide-border/60" data-testid="mig-validate-preview">
          {validation.preview.map((p) => <div key={p.label} className="flex justify-between gap-3 px-3 py-1 text-xs"><span className="text-muted-foreground">{p.label}</span><b data-testid={`mig-preview-${p.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>{p.value}</b></div>)}
        </div>
      )}
    </div>
  );
}

export function ValidateStep({ cid, batch, onValidated }) {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try { const v = await migApi.validate(cid, batch.id); toast.success("Validation complete. Nothing was written."); onValidated(v); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="space-y-3" data-testid="mig-step-validate">
      <p className="text-xs text-muted-foreground">Dry run only: NEEC Service checks every row against the mapping and existing records. Nothing is written until you confirm the import.</p>
      {batch.validation && <ValidationSummary validation={batch.validation} />}
      <Button size="sm" disabled={busy} onClick={run} data-testid="mig-validate-run"><ShieldCheck className="w-3.5 h-3.5 mr-1" /> {busy ? "Validating..." : batch.validation ? "Re-run validation" : "Run validation"}</Button>
    </div>
  );
}
